import React, { useState, useEffect, useCallback } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

const PING_URL = 'https://cloud.compsoft.com.br:8565/pedidos/ping';
const INTERVAL  = 30000; // 30 s

const ServidorSambini = () => {
  const [status, setStatus] = useState(null); // null=verificando, true=online, false=offline

  const ping = useCallback(async () => {
    try {
      const controller = new AbortController();
      const tid = setTimeout(() => controller.abort(), 10000);
      const res = await fetch(PING_URL, { signal: controller.signal });
      clearTimeout(tid);
      setStatus(res.ok); // 502/5xx = false = offline
    } catch {
      setStatus(false);
    }
  }, []);

  useEffect(() => {
    ping();
    const t = setInterval(ping, INTERVAL);
    return () => clearInterval(t);
  }, [ping]);

  const isChecking = status === null;
  const isOnline   = status === true;
  const isOffline  = status === false;

  const dotClass   = isChecking ? 'cs-dot cs-dot-idle' : isOnline ? 'cs-dot cs-dot-on' : 'cs-dot cs-dot-off';
  const badgeColor = isOffline  ? '#ef4444' : isOnline  ? '#10b981' : '#9ca3af';
  const badgeLabel = isChecking ? '...'     : isOnline  ? 'ON'      : 'OFFLINE';

  return (
    <div className="cs-servers">
      <div
        className="cs-server-row"
        style={isOffline ? { animation: 'sambini-flash 1s ease-in-out infinite', border: '1px solid #ef4444' } : undefined}
      >
        <div className="cs-server-header">
          <span className={dotClass} />
          <span className="cs-server-name">Sambini</span>
          <span className="cs-server-badge" style={{ color: badgeColor }}>{badgeLabel}</span>
        </div>
        {isOffline && (
          <div className="cs-sambini-alert">
            <FiAlertTriangle size={11} />
            Servidor Sambini OFFLINE!
          </div>
        )}
      </div>
    </div>
  );
};

export default ServidorSambini;
